export default __webpack_public_path__ + "static/media/5.fda09794.jpg";